<!-- ARIA Completed -->
@if (user$ | async; as user) {
<app-user [user]="user" />
} @else {
<a class="icon-link gap-2 link-body-emphasis text-decoration-none" [routerLink]="['/account/auth/signIn']" [queryParams]="{ continue: continueUrl || '/' }">
  <fa-icon [icon]="iconUser" [size]="'xs'" aria-hidden="true" />
  <small i18n>Giriş</small>
</a>
}